<template>
  <panel
    :title="title"
    :breadcrumbs="breadcrumbs"
  >
    <v-toolbar
      card
      extended
    >
      <v-container fluid>
        <v-layout
          row
          align-center
        >
          <v-flex>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search Dealer / MSISDN"
              solo-inverted
              clearable
              hide-details
            />
          </v-flex>

          <v-spacer />

          <v-btn
            color="primary"
            @click="getPendingPayments"
          >
            Refresh
          </v-btn>
        </v-layout>
      </v-container>
    </v-toolbar>

    <v-card>
      <v-alert
        v-if="message"
        :type="messageType"
        dismissible
        class="ma-3"
      >
        {{ message }}
      </v-alert>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          :loading="loading"
          class="px-1 pb-1"
        >
          <template #items="props">
            <tr>
              <td>{{ props.item.createdOn }}</td>

              <td>{{ props.item.msisdn }}</td>

              <td>{{ props.item.dealer }}</td>

              <td>{{ props.item.merchant_id }}</td>

              <td>{{ props.item.payment_status }}</td>

              <td>
                <v-btn
                  small
                  color="warning"
                  @click.stop="openRecovery(props.item)"
                >
                  Recover
                </v-btn>
              </td>
            </tr>
          </template>

          <template slot="no-data">
            <v-alert
              :value="true"
              :type="error ? 'error' : 'info'"
            >
              {{ noDataText }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog
      v-model="dialog"
      max-width="600"
      persistent
    >
      <v-card>
        <v-card-title class="headline">
          D288 Payment Recovery
        </v-card-title>

        <v-card-text>
          <v-text-field
            :value="selectedItem.msisdn"
            label="MSISDN"
            readonly
          />

          <v-text-field
            :value="selectedItem.merchant_id"
            label="Merchant ID"
            readonly
          />

          <v-text-field
            v-model="transactionId"
            label="NPG Transaction ID"
            required
          />

          <v-textarea
            v-model="remarks"
            label="Remarks"
            rows="3"
          />
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            flat
            @click="dialog = false"
          >
            Cancel
          </v-btn>

          <v-btn
            color="primary"
            @click="submitRecovery"
          >
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </panel>
</template>

<script>
import { createGetParams, createPostParams } from '@/rest'

const pageTitle = 'D288 Payment Recovery'

export default {
  components: {
    Panel: () => import(
      /* webpackChunkName: "panel" */
      '@/components/Panel'
    ),
  },

  data () {
    return {
      title: pageTitle,
      message: '',
      messageType: 'success',
      breadcrumbs: [
        {
          text: 'Support',
          disabled: false,
          to: '/support',
        },
        {
          text: pageTitle,
          disabled: true,
        },
      ],

      headers: [
        {
          text: 'Created On',
          value: 'createdOn',
          sortable: false,
        },
        {
          text: 'MSISDN',
          value: 'msisdn',
          sortable: false,
        },
        {
          text: 'Dealer',
          value: 'dealer',
          sortable: false,
        },
        {
          text: 'Merchant ID',
          value: 'merchant_id',
          sortable: false,
        },
        {
          text: 'Status',
          value: 'payment_status',
          sortable: false,
        },
        {
          text: 'Action',
          sortable: false,
        },
      ],

      items: [],
      loading: false,
      search: '',
      error: null,

      dialog: false,

      selectedItem: {},

      transactionId: '',

      remarks: '',
    }
  },

  computed: {
    noDataText () {
      return this.error
        ? this.error
        : "There's nothing to display."
    },
  },

  mounted () {
    this.getPendingPayments()
  },

  methods: {

    getPendingPayments () {
      this.loading = true

      const params = createGetParams({
        paymentStatus: 'pending',
        search: this.search,
      })

      this.$rest.get(
        'getD288PendingList.php',
        params,
      )
        .then(response => {
          this.items = response.data.items
          this.loading = false
        })
        .catch(error => {
          console.log(error)
          this.error = error.message
          this.loading = false
        })
    },

    openRecovery (item) {
      this.selectedItem = item
      this.transactionId = ''
      this.remarks = ''
      this.dialog = true
    },

    submitRecovery () {
      if (!this.transactionId) {
        this.message = 'NPG Transaction ID is required'
        this.messageType = 'error'
        return
      }

      const params = createPostParams({
        action: 'recoverD288Payment',
        orderId: this.selectedItem.id,
        merchantId: this.selectedItem.merchant_id,
        transactionId: this.transactionId,
        msisdn: this.selectedItem.msisdn,
        remarks: this.remarks,
      })

      this.$rest.post(
        'postAction.php',
        params,
      )
        .then(() => {
          this.dialog = false

          this.getPendingPayments()

          this.message = 'D288 payment recovered successfully'
          this.messageType = 'success'
        })
        .catch(error => {
          console.log(error)

          this.message =
  error.response &&
  error.response.data
    ? error.response.data
    : error.message

          this.messageType = 'error'
        })
    },
  },
}
</script>
